<template>
  <div class="shop-container">
    <div class="title-store">
      <i :class="`icon-${type}`"></i>
      <div class="label-box">
        <span class="label-shadow">{{ title }}</span>
        <span class="label-text">{{ title }}</span>
      </div>
    </div>
    <ul v-if="goodsList">
      <li v-for="(goods) in goodsList" :key="goods.goodsId" @click="exchange(goods, type)">
        <div class="goods-container" :class="isMall ? 'pricebg' : 'residentbg'">
          <div class="desc">
            <div class="label-box">
              <span class="label-shadow">{{ goods.desc }}</span>
              <span class="label-text">{{ goods.desc }}</span>
            </div>
          </div>
          <div class="pesticide">剩余{{ isMall ? goods.dailyLimit - goods.dailyReward : goods.totalLimit -
            goods.totalReward }}</div>
          <div class="quan"></div>
          <div class="icon" :style="{ 'background-image': `url(${goods.imgUrl})` }">
            <div class="num">
              x{{ goods.num }}
            </div>
          </div>
          <div class="price" v-if="isMall">
            <div v-if="goods.dailyLimit > goods.dailyReward" class="centering">
              <i></i>{{ goods.cost }}
              <div class="dot" v-show="goods.cost === 1"></div>
            </div>
          </div>
          <div class="price resident" v-else>
            <div v-if="goods.totalLimit >= goods.totalReward" class="centering">
              <i></i>{{ goods.cost }}
            </div>
          </div>
        </div>
        <div v-if="isMall" v-show="goods.dailyReward >= goods.dailyLimit" class="mask">
          <div class="sellout">售罄</div>
        </div>
        <div v-else v-show="goods.totalReward >= goods.totalLimit" class="mask">
          <div class="sellout">售罄</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'

defineOptions({ name: 'DailyShop' })

const props = defineProps({
  goodsList: {
    type: Array,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  type: {
    type: String,
    required: true
  }
})

const emit = defineEmits(['exchange'])

const countdown = ref('加载中...')

const isMall = computed(() => props.type === 'mall')

function exchange(goods, type) {
  emit('exchange', goods, type);
}

watch(countdown, () => {
  // this.formatCountdown()
}, { immediate: true })
</script>

<style lang="scss" scoped>
@mixin textShadow($size, $color) {
  text-shadow: 0px -#{$size} $color,
  -#{$size} 0px $color,
  #{$size} 0px $color,
  0px #{$size} $color,
  #{$size} -#{$size} $color,
  -#{$size} -#{$size} $color,
  -#{$size} #{$size} $color,
  #{$size} #{$size} $color;
}


.shop-container {
  .title-store {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    height: fit-content;
    font-size: get_vw(24);
    margin-bottom: get_vw(14);

    .label-box .label-shadow {
      color: #6F0A0B;
    }

    i {
      position: relative;
      width: get_vw(36);
      height: get_vw(36);
      margin-right: get_vw(8);

      &.icon-mall {
        @include icon_status('store_daily_1');
      }
      &.icon-resident {
        @include icon_status('store_resident_1');
      }
    }
  }


  ul {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    li {
      position: relative;
      width: get_vw(338);
      height: get_vw(100);
      margin-bottom: get_vw(10);
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      @include boxShadowSet_Btn();

      .goods-container {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        border-radius: get_vw(10);
        border: get_vw(4) solid #FFFFFF;
        overflow: hidden;

        &.pricebg {
          background-image: url(https://website.xdcdn.net/poster/58881/26match/common/QQjioad1.png);
        }

        &.residentbg {
          background-image: url(https://website.xdcdn.net/poster/58881/26match/common/QQjjbddx.png);
        }
      }

      .mask {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: absolute;
        top: 0;
        left: 0;
        border-radius: get_vw(10);
        overflow: hidden;
        display: flex;
        align-items: center;
        .sellout {
          position: relative;
          width: 100%;
          height: get_vw(40);
          background-color: rgba(0, 0, 0, 0.3);
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #fff;
          @include r(font-size, 20);
        }
      }

      .desc {
        position: absolute;
        top: get_vw(9);
        right: get_vw(12);
        // @include fontSet($size: 20);
        font-size: get_vw(20);
        text-align: left;

        .label-box {
          .label-shadow {
            color: #fff;
          }

          .label-text {
            color: #333;
          }
        }
      }

      .pesticide {
        position: absolute;
        top: get_vw(46);
        right: get_vw(12);
        height: get_vw(12);
        border-radius: get_vw(10);
        background-color: rgba(255, 255, 255, 0.5);
        font-size: get_vw(16);
        padding: get_vw(5) get_vw(9);
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #666;
      }

      .quan {
        position: absolute;
        top: get_vw(14);
        left: get_vw(16);
        width: get_vw(74);
        height: get_vw(74);
        background-image: url(https://website.xdcdn.net/poster/58881/26match/common/QQj7Yk83.png);
        filter: drop-shadow(0 get_vw(2) get_vw(4) #c5c6ca);
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
      }

      .icon {
        position: absolute;
        top: get_vw(21);
        left: get_vw(6.47);
        width: get_vw(93.77);
        height: get_vw(61.72);
        background-position: center;
        background-repeat: no-repeat;
        background-size: contain;
      }

      .num {
        font-size: get_vw(16);
        text-align: right;
        position: absolute;
        top: get_vw(42);
        right: get_vw(15);
        color: #000;
        font-weight: 500;
        @include textShadow(2px, #fff);

      }

      .price {
        width: get_vw(152);
        height: get_vw(32);
        position: absolute;
        right: get_vw(2);
        bottom: get_vw(2);
        display: flex;
        align-items: flex-end;
        justify-content: flex-end;
        background-image: url('https://website.xdcdn.net/poster/58881/20250717/K91Y8XMc.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        color: #333;
        border-radius: 0 0 get_vw(10) 0;
        font-size: get_vw(16);

        .centering {
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: get_vw(12);

          .dot {
            position: absolute;
            width: get_vw(8);
            height: get_vw(8);
            right: 36%;
            top: 50%;
            margin-top: get_vw(-1);
            background-color: #CA3939;
            border: get_vh(1) solid #fff;
            border-radius: 50%;
          }
        }

        i {
          position: relative;
          top: get_vw(-1);
          display: inline-block;
          @include icon_status('quiz_coin');
          width: get_vw(19.26);
          height: get_vw(20.22);
          margin-right: get_vw(3.74)
        }
      }
    }

    li:nth-child(4n+1),
    li:nth-child(4n+2),
    li:nth-child(4n+3) {
      margin-right: get_vw(16);
    }
  }
}
</style>
